import { type SignatureCode, signatures } from 'shared/signatures';

export const signMethodCalculate = (
  type: 'sign' | 'accept',
  document?: any,
) => {
  const signeSigneMethod: SignatureCode[] =
    document?.availableSignMethods || [];

  if (type === 'sign') {
    return signeSigneMethod[0] || 'ASSECO';
  } else {
    const acceptMethod = signatures
      .getDocumentSignatures()
      .map(signature => signature.code);

    return (
      signeSigneMethod.filter(method => acceptMethod.includes(method))[0] ||
      'SIMPLE'
    );
  }
};
